import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecurityLevelEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-level-edit',
	path: '/secure/admin/EditSecurityLevel!default.jspa',
};
